module.exports = __webpack_public_path__ + "static/media/Logo_Footer.7daf50ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo_Footer.svg
// module id = 959
// module chunks = 0